import { render } from "./ContactTab.vue?vue&type=template&id=6fc713e4&scoped=true"
import script from "./ContactTab.vue?vue&type=script&lang=js"
export * from "./ContactTab.vue?vue&type=script&lang=js"

import "./ContactTab.vue?vue&type=style&index=0&id=6fc713e4&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6fc713e4"]])

export default __exports__